import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconCollapseVerticalStyle0 = gravityIconIndividualCss;

const GravityIconCollapseVertical = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '240a13a43c342f672d68c925f6e62139e027fde3', color: this.color, size: this.size }, h("svg", { key: '55c8fadeaba5880b7e126501c4bda405ada9c68a', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '904d142440dd13a8c25fba2a5ded80c2c4c262a3', d: "M14.35 4.035C14.69 3.63 14.414 3 13.895 3h-5.79c-.519 0-.796.631-.454 1.035l2.895 3.419a.59.59 0 0 0 .908 0l2.896-3.42ZM3 10.75a.5.5 0 0 1 .5-.5h15a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-15a.5.5 0 0 1-.5-.5v-.5Zm5.105 8.247c-.519 0-.796-.632-.454-1.035l2.895-3.419a.59.59 0 0 1 .908 0l2.896 3.42c.341.402.064 1.034-.455 1.034h-5.79Z", fill: "currentColor" }))));
    }
};
GravityIconCollapseVertical.style = GravityIconCollapseVerticalStyle0;

export { GravityIconCollapseVertical as gravity_icon_collapse_vertical };

//# sourceMappingURL=gravity-icon-collapse-vertical.entry.js.map